import { otherRouter, appRouter } from '@/router/router';
import AppUtil from './appUtil';
import Util from '@/libs/util';

const app = {
    state: {
        cachePage: [], //mainContent的缓存页面
        mainCachePage: ['home'], //main.vue的缓存页面
        menuTheme: 'dark', // 主题
        themeColor: '',

        // 侧边栏
        menuList: [],
        activeName: '', // 侧边栏选中的menu
        openNames: [], // 侧边栏展开的菜单数组

        // 面包屑和标签列表
        // 当前打开的标签
        currentOpenedTag: {
            name: 'home_index',
            path: '',
            title: '首页',
            parents: []
        },
        // 打开的标签数字
        openedTags: [{
            title: '首页',
            path: '',
            name: 'home_index'
        }],
        dontCache: [], // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
        // 地区区域树
        area: [],
        //判断是否全屏
        indextrue: false,
        // 地图模式的轨迹参数
        bikeTrackData: {
            id: '',
            udid: ''
        },
        screenData: null,
        thirdLive: {
            url: null,
            name: null,
            status: false
        },
        thirdcheckZoom: true,
        thirdliveShow: 0,
        peccancyif: false,
        peccancyData: {
            //类型
            typeLabel: 'null',
            //公司
            companyId: 'null',
            //公司切换
            companyin: true,
            //时间
            timeval: ['', ''],
            open: false,
            //分页信息
            page: {
                total: 0,
                pageNum: 1,
                pageSize: 10,
            },
        },
        //共配大屏
        // wsurl: 'api.tes.e-dewin.com',
        wsurl: 'api.rls.e-dewin.com',
        // wsurl: 'api.e-dewin.com',
        showcityname: '',
        level: 1,
        showarea: {
            areaId: '',
            cityId: '',
            provinceId: '',
        },
        showareaname: {
            areaName: '',
            cityName: '',
            provinceName: '',
        },

    },
    mutations: {
        updateMenulist(state) {
            // 路由生成订单
            // state.menuList = appRouter;

            // 网络请求订单
            let menu = window.localStorage.getItem("menu");
            state.menuList = JSON.parse(menu);
        },
        changeMenuTheme(state, theme) {
            state.menuTheme = theme;
        },
        changeMainTheme(state, mainTheme) {
            state.themeColor = mainTheme;
        },

        // 清空缓存
        clearCache(state) {
            this.$store.commit('clearOpenedTags'); // 清空已打开标签列表
            this.$store.commit('clearCachePage'); // 清空缓存页面列表
        },

        // 侧边栏
        // 根据路由计算菜单信息，path(网络请求路由)
        addOpenSubmenu(state, path) {
            let paths = AppUtil.combinationPath(state.menuList);

            for (let i in paths) {
                let subPath = paths[i];

                if (path.indexOf(subPath) >= 0) { // 包含菜单目录
                    state.activeName = subPath;
                    state.openNames = AppUtil.decompoundPath(subPath);
                    return;
                } else {
                    state.activeName = '';
                    state.openNames = [];
                }
            }
        },

        // 标签
        // 初始化已打开标签列表
        initOpenedTags(state) {
            let openedTags = localStorage.getItem('openedTags');
            state.openedTags = openedTags ? JSON.parse(openedTags) : [];
        },
        // 添加标签已打开标签列表
        addOpenedTags(state, router) {
            let previousOpenedTag = null;
            for (let tag of state.openedTags) {
                if (tag.name == router.name) {
                    previousOpenedTag = tag;
                    break;
                }
            }

            let arr = router.path.split("/").slice(1); // 去掉根目录产生的空字符串
            let paths = AppUtil.searchPath(arr, appRouter.concat(...otherRouter.children).concat({
                path: 'home',
                title: '首页',
                name: 'home_index'
            }));

            let title = '';
            if (paths.length > 0) {
                title = paths[paths.length - 1].title;
            }

            state.currentOpenedTag = {
                name: router.name,
                path: router.path,
                title: typeof title === 'undefined' ? '' : title,
                parents: paths
            };
            // 判断是否已经打开
            if (!previousOpenedTag) {
                let tag = {
                    name: router.name,
                    path: router.fullPath,
                    title: typeof title === 'undefined' ? '' : title,
                };
                state.openedTags.push(tag);
                // 如果是未打开的标签，加入缓存列表
                if (!Util.oneOf(tag.name, state.cachePage)) {
                    state.cachePage.push(tag.name);
                    localStorage.cachePage = JSON.stringify(state.cachePage);
                    localStorage.openedTags = JSON.stringify(state.openedTags);
                }
            }
            state.openedTags.forEach((item, index) => {
                if (item.path != router.fullPath && item.name == router.name) {
                    state.openedTags[index].path = router.fullPath;
                }
            });
        },
        // 删除签已打开标签列表
        removeOpenedTags(state, tag) {
            for (let index in state.openedTags) {
                let openedTag = state.openedTags[index];
                if (openedTag.name === tag.name) {
                    state.openedTags.splice(index, 1);
                    localStorage.openedTags = JSON.stringify(state.openedTags);
                    break;
                }
            }
        },
        // 去除缓存页面
        closePage(state, name) {
            state.cachePage.forEach((item, index) => {
                if (item === name) {
                    state.cachePage.splice(index, 1);
                }
            });
        },
        initCachepage(state) {
            if (localStorage.cachePage) {
                state.cachePage = JSON.parse(localStorage.cachePage);
            }
        },
        // 清空已打开标签列表
        clearOpenedTags(state, tag) {
            state.openedTags = [];
            if (tag != null) {
                state.openedTags.push(tag);
            }
            // 将openTags清空
            localStorage.openedTags = state.openedTags;
        },
        // 清空缓存页面列表
        clearCachePage(state, tag) {
            state.cachePage = [];
            if (tag != null) {
                state.cachePage.push(tag.name);
            }
        },
        // 保存已打开标签列表
        saveOpenedTags(state) {
            this.localStorage.setItem('openedTags', state.openedTags);
        },
        // 获取全国区域树
        initAreaTree(state, tree) {
            state.area = tree;
        }
    }
};

export default app;


// WEBPACK FOOTER //
// ./src/store/modules/app.js